export default __webpack_public_path__ + "static/media/buyWait.e8a6cf68.svg";